import React, {useRef, useState} from "react";
import Form from "react-bootstrap/Form";
import {Alert, Button} from "react-bootstrap";
import {useAuth} from "../contexts/AuthContext";

export default function AddUserComponent({maxUsersLimitReached, companyValues, loading}) {

    const {signup} = useAuth();
    const [error, setError] = useState(false);
    const [errorText, setErrorText] = useState("");
    const [addingUser, setAddingUser] = useState(false);
    const [errorType, setErrorType] = useState("");

    const emailRef = useRef();
    const firstnameRef = useRef();
    const passwordRef = useRef();
    const lastnameRef = useRef();
    const authRef = useRef();

    async function handleSubmit(e) {
        e.preventDefault();

        if (!emailRef.current.value) {
            setError(true);
            setErrorText("Ange email ");
            setErrorType("warning")
            return;
        } else if (!firstnameRef.current.value) {
            setError(true);
            setErrorText("Ange förnamn ");
            setErrorType("warning")

            return;
        } else if (!lastnameRef.current.value) {
            setError(true);
            setErrorText("Ange efternamn ");
            setErrorType("warning")

            return;
        } else if (!authRef.current.value) {
            setError(true);
            setErrorText("Ange behörighet ");
            setErrorType("warning")

            return;

        } else if (!passwordRef.current.value) {
            setError(true);
            setErrorText("Ange lösenord ");
            setErrorType("warning")

            return;
        } else {
            try {
                setError(true);
                setAddingUser(true)

                await signup(
                    emailRef.current.value,
                    passwordRef.current.value,
                    firstnameRef.current.value,
                    lastnameRef.current.value,
                    authRef.current.value,
                    companyValues.companyName
                );

                setErrorType("success")
                setErrorText("Användare tillagd");

            } catch (err) {
                setErrorType("warning")

                setErrorText("Misslyckat försök");

            } finally {

                setAddingUser(false)
                window.location.reload();

            }
        }
    }

    return (
        <React.Fragment>
            <Form
                onSubmit={handleSubmit}
                style={{padding: "30px", margin: " 30px"}}
            >
                {error && <Alert variant={errorType}>{errorText}</Alert>}
                <h4>Lägg till användare</h4>
                <Form.Group id="email">
                    <Form.Label>E-post</Form.Label>
                    <Form.Control
                        type="email"
                        ref={emailRef}
                        placeholder="example@företag.se"
                    />
                </Form.Group>
                <Form.Group id="firstName">
                    <Form.Label>Förnamn</Form.Label>
                    <Form.Control type="text" ref={firstnameRef} placeholder="Förnamn"/>
                </Form.Group>
                <Form.Group id="lastName">
                    <Form.Label>Efternamn</Form.Label>
                    <Form.Control type="text" ref={lastnameRef} placeholder="Efternamn"/>
                </Form.Group>
                <Form.Group id="passowrd">
                    <Form.Label>Lösenord</Form.Label>
                    <Form.Control type="text" ref={passwordRef} placeholder="******"/>
                </Form.Group>

                <Form.Group id="company">
                    <Form.Label>Företag</Form.Label>
                    <Form.Control
                        type="text"
                        disabled={true}
                        value={companyValues.companyName}
                    />
                </Form.Group>


                <Form.Label>Ange Behörighet</Form.Label>
                <Form.Control
                    as="select"
                    id="auth"
                    ref={authRef}
                    placeholder="Välj behörighet"
                >
                    <option value="App">App</option>
                    <option value="Webb">Webb</option>
                </Form.Control>

                <hr/>

                <Button
                    disabled={loading || maxUsersLimitReached || addingUser}
                    className="w-100"
                    type="submit"
                >
                    Skapa användare
                </Button>
                {maxUsersLimitReached && <Alert variant="danger">Max antal licenser använda</Alert>}
            </Form>
        </React.Fragment>
    );
}
